// extracted by mini-css-extract-plugin
module.exports = {"pdpServiceAvailabilityWrapper":"ServiceAvailability_pdpServiceAvailabilityWrapper__PDj5C"};